import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();

  const [isDashboard, setIsDashboard] = useState(false);
  const [isBookings, setIsBookings] = useState(false);
  const [isTeam, setIsTeam] = useState(false);
  const [isServices, setIsServices] = useState(false);
  const [isTask, setIsTask] = useState(false);
  const [isSettings, setIsSettings] = useState(false);
  const [isOrders, setIsOrders] = useState(false);
  const [isHousekeeping, setIsHousekeeping] = useState(false);
  const [isKot, setIsKot] = useState(false);
  const [isRoom, setIsRoom] = useState(false);
  const [isRevenue, setIsRevenue] = useState(false);
  const [iscurrentState, setIscurrentState] = useState(false);
const [isTaxi, setIsTaxi] = useState(false);


  /////Channel Manager:

  const [isChannelDashboard, setIsChannelDashboard] = useState(false);
  const [isChannelInventory, setIsChannelInventory] = useState(false);
  const [isChannelRates, setIsChannelRates] = useState(false);
  const [isChannelRestrictions, setIsChannelRestrictions] = useState(false);
  const [isChannelRoomMapping, setIsChannelRoomMapping] = useState(false);
  const [isChannelSyncLogs, setIsChannelSyncLogs] = useState(false);
  const [isChannelBookingLogs, setIsChannelBookingLogs] = useState(false);
  const [isChannelSettings, setIsChannelSettings] = useState(false);
  const [isChannels, setIsChannels] = useState(false);
  const [isChannelManager, setIsChannelManager] = useState(false);
 

  // ✅ SAFE USER FETCH
  const user = JSON.parse(localStorage.getItem("user")) || {};

  // ✅ NORMALIZE (VERY IMPORTANT)
  const role = (user.role || "").toLowerCase();
  const dept = (user.department || "").toLowerCase();

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      [...iconItems].forEach((item) => {
        item.classList.remove("active");
        const id = item.getAttribute("subitems");
        if (document.getElementById(id)) {
          document.getElementById(id).classList.remove("show");
        }
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");

    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }

    if (iscurrentState !== "ChannelManager") {
  setIsChannelManager(false);
}

      if (iscurrentState !== "Orders") {
      setIsOrders(false);
    }

    if (iscurrentState !== "Bookings") {
      setIsBookings(false);
    }

     if (iscurrentState !== "Housekeeping") {
      setIsHousekeeping(false);
    }

    if (iscurrentState !== "Team") {
      setIsTeam(false);
    }

    if (iscurrentState !== "Services") {
      setIsServices(false);
    }

        if (iscurrentState !== "Taxi") {
  setIsTaxi(false);
}

    if (iscurrentState !== "Task") {
      setIsTask(false);
    }

     if (iscurrentState !== "Room") {
      setIsRoom(false);
    }

      if (iscurrentState !== "Kot") {
      setIsKot(false);
    }

       if (iscurrentState !== "Revenue"){
      setIsRevenue(false);
    }

    if (iscurrentState !== "Settings") {
      setIsSettings(false);
    }

  }, [
    history,
    iscurrentState,
    isDashboard,
    isOrders,
    isBookings,
    isTeam,
    isServices,
    isTaxi,
    isTask,
    isSettings,
    isHousekeeping,
    isRoom,
    isKot,
    isRevenue
  ]);
 
// =====================================================
// 🧑‍💼 ADMIN (FULL MENU WITH DROPDOWNS)
// =====================================================

const adminMenu = [

  // =====================================================
  // CHANNEL MANAGER
  // =====================================================

  {
    label: "CHANNEL MANAGER",
    isHeader: true,
  },

  {
    id: "channelmanager",
    label: "Channel Manager",
    icon: "ri-exchange-box-line",
    link: "/#",
    className: "channel-manager-box",
    stateVariables: isChannelManager,

    click: function (e) {
      e.preventDefault();

      setIsChannelManager(!isChannelManager);

      setIscurrentState("ChannelManager");

      updateIconSidebar(e);
    },

    subItems: [

      {
        id: "cmdashboard",
        label: "Dashboard",
        link: "/channel-manager/dashboard",
        parentId: "channelmanager",
      },

      {
        id: "cminventory",
        label: "Inventory",
        link: "/channel-manager/inventory",
        parentId: "channelmanager",
      },

      {
        id: "cmrates",
        label: "Rates",
        link: "/channel-manager/rates",
        parentId: "channelmanager",
      },

      {
        id: "cmrestrictions",
        label: "Restrictions",
        link: "/channel-manager/restrictions",
        parentId: "channelmanager",
      },

      {
        id: "cmroommapping",
        label: "Room Mapping",
        link: "/channel-manager/room-mapping",
        parentId: "channelmanager",
      },

      {
        id: "cmsynclogs",
        label: "Sync Logs",
        link: "/channel-manager/sync-logs",
        parentId: "channelmanager",
      },

      {
        id: "cmbookinglogs",
        label: "Booking Logs",
        link: "/channel-manager/booking-logs",
        parentId: "channelmanager",
      },

      {
        id: "cmchannels",
        label: "Channels",
        link: "/channel-manager/channels",
        parentId: "channelmanager",
      },

      {
        id: "cmsettings",
        label: "Settings",
        link: "/channel-manager/settings",
        parentId: "channelmanager",
      },

    ],
  },


  // =====================================================
  // PMS
  // =====================================================

  {
    label: "PMS",
    isHeader: true,
  },


  // =====================================================
  // DASHBOARD ANALYTICS
  // =====================================================

  {
    id: "dashboardanalytics",
    label: "Dashboard Analytics",
    icon: "ri-dashboard-2-line",
    link: "/dashboard",
  },


  // =====================================================
  // RESERVATION
  // =====================================================

  {
    id: "reservation",
    label: "Reservation",
    icon: "ri-calendar-line",
    link: "/reservation",
  },

    // =====================================================
  // Orders & Billing
  // =====================================================

 {
  id: "ordersBilling",
  label: "Orders & Billing",
  icon: "ri-restaurant-2-line",
  link: "/#",
  stateVariables: isKot,

  click: function (e) {
    e.preventDefault();
    setIsKot(!isKot);
    setIscurrentState("Kot");
    updateIconSidebar(e);
  },

  subItems: [
    {
      id: "orders",
      label: "Create Order",
      link: "/create-order",
      parentId: "kot",
    },

    {
      id: "billing",
      label: "My Orders",
      link: "/manage-orders",
      parentId: "Kot",
    },
  ],
},


  // =====================================================
  // HOUSEKEEPING
  // =====================================================

  {
    id: "housekeeping",
    label: "Housekeeping",
    icon: "ri-brush-line",
    link: "/#",
    stateVariables: isHousekeeping,

    click: function (e) {
      e.preventDefault();

      setIsHousekeeping(!isHousekeeping);

      setIscurrentState("Housekeeping");

      updateIconSidebar(e);
    },

    subItems: [

      {
        id: "housekeepingDashboard",
        label: "Dashboard",
        link: "/housekeeping-dashboard",
        parentId: "housekeeping",
      },

      {
        id: "housekeepingRequest",
        label: "Request",
        link: "/service-request",
        parentId: "housekeeping",
      },

    ],
  },


  // =====================================================
  // TEAM MANAGEMENT
  // =====================================================

  {
    id: "manageteam",
    label: "Team Management",
    icon: "las la-users-cog",
    link: "/team",
  },

  // =====================================================
// SERVICES
// =====================================================

{
  id: "services",
  label: "Services",
  icon: "las la-concierge-bell",
  link: "/#",
  stateVariables: isServices,

  click: function (e) {
    e.preventDefault();

    setIsServices(!isServices);

    setIscurrentState("Services");

    updateIconSidebar(e);
  },

  subItems: [

    {
      id: "manageservices",
      label: "Manage Services",
      link: "/services",
      parentId: "services",
    },
  ],
},

  // =====================================================
  // SPA MANAGEMENT
  // =====================================================

  // {
  //   id: "spabookings",
  //   label: "SPA Management",
  //   icon: "las la-spa",
  //   link: "/spa-dashboard",
  // },


  // =====================================================
  // ROOM MANAGEMENT
  // =====================================================

  {
    id: "room",
    label: "Room Management",
    icon: "las la-bed",
    link: "/#",
    stateVariables: isRoom,

    click: function (e) {
      e.preventDefault();

      setIsRoom(!isRoom);

      setIscurrentState("Room");

      updateIconSidebar(e);
    },

    subItems: [

      {
        id: "manageRooms",
        label: "Manage Rooms",
        link: "/manage-room",
        parentId: "room",
      },

      {
        id: "roomTypes",
        label: "Manage Room Types",
        link: "/room-types",
        parentId: "room",
      },

    ],
  },


  // =====================================================
  // TAXI MANAGEMENT
  // =====================================================

  {
    id: "taxi",
    label: "Taxi Management",
    icon: "las la-car",
    link: "/#",
    stateVariables: isTaxi,

    click: function (e) {
      e.preventDefault();

      setIsTaxi(!isTaxi);

      setIscurrentState("Taxi");

      updateIconSidebar(e);
    },

    subItems: [

      {
        id: "managetaxi",
        label: "Manage Taxis",
        link: "/taxi-management",
        parentId: "taxi",
      },

      {
        id: "taxibookings",
        label: "Taxi Bookings",
        link: "/taxi-bookings",
        parentId: "taxi",
      },

    ],
  },


  // =====================================================
  // REVENUE MANAGEMENT
  // =====================================================

  {
    id: "revenueManagement",
    label: "Revenue",
    icon: "las la-file-invoice-dollar",
    link: "/revenue",
  },


  // =====================================================
  // REPORTS
  // =====================================================

  {
    id: "reports",
    label: "Reports",
    icon: "las la-chart-bar",
    link: "/report",
  },

];

  // =====================================================
  // 🧹 HOUSEKEEPING
  // =====================================================
  const housekeepingMenu = [
    { label: "Menu", isHeader: true },
    { label: "Housekeeping", icon: "las la-broom", link: "/service-request" },
    { label: "Manage Team", icon: "las la-users-cog", link: "/team" },
    { label: "Manage Services", icon: "las la-concierge-bell", link: "/services" },
    { label: "Complaints", icon: "las la-comment", link: "/complaints" },
    { label: "Settings", icon: "las la-cog", link: "/setting-services" },
  ];

  // =====================================================
  // 🏨 FRONT OFFICE
  // =====================================================
  const frontOfficeMenu = [
    { label: "Menu", isHeader: true },
    { label: "Dashboard", icon: "ri-dashboard-2-line", link: "/dashboard" },
    { label: "Reservation", icon: "ri-calendar-line", link: "/reservation" },
    { label: "Manage Team", icon: "las la-users-cog", link: "/team" },
    { label: "Manage Rooms", icon: "las la-warehouse", link: "/rooms" },
    { label: "Manage Checkout", icon: "las la-share-square", link: "/checkout" },
    { label: "Complaints", icon: "las la-comment", link: "/complaints" },
    { label: "Settings", icon: "las la-cog", link: "/setting-services" },
  ];

  // =====================================================
  // 🍽 F&B
  // =====================================================
  const fbMenu = [
    { label: "Menu", isHeader: true },
    { label: "Manage Booking", icon: "las la-utensils", link: "/food-dine" },
    { label: "Manage Services", icon: "las la-concierge-bell", link: "/services" },
    { label: "Manage Team", icon: "las la-users-cog", link: "/team" },
    { label: "Manage Task", icon: "las la-clipboard-check", link: "/task" },
    { label: "Complaints", icon: "las la-comment", link: "/complaints" },
    { label: "Settings", icon: "las la-cog", link: "/setting-services" },
  ];

  // =====================================================
  // 💆 SPA
  // =====================================================
  const spaMenu = [
    { label: "Menu", isHeader: true },
    { label: "Manage Team", icon: "las la-users-cog", link: "/team" },
    { label: "Spa Bookings", icon: "las la-spa", link: "/spa-dashboard" },
    { label: "Complaints", icon: "las la-comment", link: "/complaints" },
    { label: "Settings", icon: "las la-cog", link: "/setting-services" },
  ];

  // =====================================================
  // 🧑‍💼 MANAGEMENT
  // =====================================================
  const managementMenu = [
    { label: "Menu", isHeader: true },
    { label: "Manage Team", icon: "las la-users", link: "/team" },
    { label: "Manage Bookings", icon: "las la-bed", link: "/dashboard" },
    { label: "Taxi Booking", icon: "las la-car", link: "/taxi-bookings" },
    { label: "Manage Services", icon: "las la-concierge-bell", link: "/services" },
    { label: "Manage Task", icon: "las la-clipboard-check", link: "/task" },
    { label: "Emergency", icon: "las la-briefcase-medical", link: "/health" },
    { label: "Complaints", icon: "las la-comment", link: "/complaints" },
  ];

  // =====================================================
  // 🔥 FINAL SWITCH (FIXED)
  // =====================================================
  let menuItems = [];

  // ✅ ADMIN (client = admin)
  if (role === "client" || role === "admin") {
    menuItems = adminMenu;
  }

  // ✅ MANAGER
  else if (role === "manager") {
    if (dept.includes("housekeeping")) menuItems = housekeepingMenu;
    else if (dept.includes("front")) menuItems = frontOfficeMenu;
    else if (dept.includes("f&b") || dept.includes("fb")) menuItems = fbMenu;
    else if (dept.includes("spa")) menuItems = spaMenu;
    else if (dept.includes("management")) menuItems = managementMenu;
  }

  return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;